<div class="hoffman-confirm-dialog">
    <div class="d-flex flex-column align-items-center mb-3">
        <img src="assets/icons/warningPayment.svg" alt="warning">
        <p class="mb-0 text-size-3 text-center" [innerHTML]="text | sanitizeHtml"></p>
    </div>
    <mat-dialog-actions>
        <button mat-stroked-button class="with-buttons font-size-button d-flex flex-nowrap white-button"
            autofocus="false" color="primary" matDialogClose>
            Regresar
        </button>
        <button mat-raised-button class="with-buttons font-size-button blue-button margin-button" color="primary" 
        (click)="continue()">
            Envíar a carrito
        </button>
    </mat-dialog-actions>
</div>